<div class="organization-page">
  <div class="card">
    <div class="page-header">
      <div class="header-left">
        <a
          routerLink="/administration"
          class="nav-link"
          [attr.title]="'administration.addOrganization.backToAdministration' | translate"
          [attr.aria-label]="'administration.addOrganization.backToAdministration' | translate"
        >
          <lucide-angular name="arrow-left" [size]="18" class="card-icon card-icon-gray"></lucide-angular>
        </a>

        <div class="page-header-text">
          <h2 class="page-title">{{ "administration.organization.title" | translate }}</h2>
          <div class="label" *ngIf="organizationDetails">
            {{ "administration.organization.name" | translate }}:
            <span class="highlight">{{ organizationDetails.details.name }}</span>
          </div>
        </div>
      </div>

      <div class="header-right">
        <app-invite-member-button
          *ngIf="isCurrentOrganization && canInviteMember"
          (memberInvited)="reloadOrganizationDetails()"
        ></app-invite-member-button>
      </div>
    </div>
  </div>

  <app-organization-details
    [details]="organizationDetails"
    (invitationChanged)="reloadOrganizationDetails()"
    (memberChanged)="reloadOrganizationDetails()"
  ></app-organization-details>
</div>
